import { TOKEN_TYPE } from "../TokenType.js";
import Token from "../Token.js";

export default class StringToken extends Token {
    constructor( value ) {
        super( TOKEN_TYPE.STRING, value );
    }

    toString() {
        return this.value;
    }
}
